import {
  WORKSPACE_ROLE_PERMISSION_UPDATE_ERROR,
  WORKSPACE_ROLE_PERMISSION_UPDATE_REQUEST,
  WORKSPACE_ROLE_PERMISSION_UPDATE_SUCCESS,
} from "../../Types/user/Types";

const initialState = {
  error: "",
  workspace_role_permission_update_data: "",
  loader: false,
};
const workspace_Role_Permission_Update_Reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case WORKSPACE_ROLE_PERMISSION_UPDATE_SUCCESS:
      return {
        ...initialState.workspace_role_permission_update_data,
        error: "",
        workspace_role_permission_update_data: action.payload,
        loader: false,
      };
    case WORKSPACE_ROLE_PERMISSION_UPDATE_ERROR:
      return {
        ...initialState.workspace_role_permission_update_data,
        error: action.error,
        workspace_role_permission_update_data: "",
        loader: false,
      };
    case WORKSPACE_ROLE_PERMISSION_UPDATE_REQUEST:
      return {
        ...initialState.workspace_role_permission_update_data,
        error: null,
        workspace_role_permission_update_data: "",
        loader: true,
      };
    default:
      return state;
  }
};

export default workspace_Role_Permission_Update_Reducer;
